import request from '@/utils/request'

export interface IAdminOperationLog {
  id: number
  operatorId?: number
  operatorName?: string
  operatorUsername?: string
  operatorRole?: number
  operatorStoreId?: number
  module?: string
  action?: string
  method?: string
  uri?: string
  requestParams?: string
  ip?: string
  success?: number
  errorMsg?: string
  costMs?: number
  createTime?: string
}

export function getOperationLogPage(params: {
  pageNum: number
  pageSize: number
  operatorKeyword?: string
  keyword?: string
  success?: number | null
  storeId?: number
  beginTime?: string
  endTime?: string
}) {
  return request({
    url: '/operationLog/page',
    method: 'get',
    params
  })
}
